"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPLY_JOIN_SPACE = exports.JOIN_VIA_LINK = exports.LINK_VALID = exports.DELETE_LINK = exports.LINK_LIST = exports.CREATE_LINK = exports.CAPACITY_REWARD_LIST = exports.NO_PERMISSION_MEMBER = exports.SPACE_RESOURCE = exports.SUBSCRIBE_INFO = exports.SPACE_STATISTICS = exports.GET_ALL_VISIBLE = exports.UPDATE_ALL_VISIBLE = exports.SPACE_MEMORY = exports.RECOVER_SPACE = exports.SPACE_INFO = exports.SPACE_CONTENT = exports.UPDATE_SECURITY_SETTING = exports.SWITCH_NODEROLE_ASSIGNALE = exports.GET_SPACE_FEATURES = exports.UPDATE_WORKBENCH_SETTING = exports.FORBID_STATUS = exports.UPDATE_MEMBER_SETTING = exports.DELETE_SUB_ADMIN = exports.EDIT_SUB_ADMIN = exports.ADD_SUB_ADMIN = exports.SUB_ADMIN_PERMISSION = exports.LIST_ROLE = exports.CHANGE_MAIN_ADMIN = exports.MAIN_ADMIN_INFO = exports.QUIT_SPACE = exports.REMOVE_RED_POINT = exports.UPDATE_SPACE = exports.DELETE_SPACE_NOW = exports.SWITCH_SPACE = exports.DELETE_SPACE = exports.CREATE_SPACE = exports.SPACE_LIST = exports.SPACE_AUDIT = void 0;
// ================ Audit ======================
/**
 * Query space audit logs with pagination
 */
exports.SPACE_AUDIT = '/space/:spaceId/audit';
// =============== Space related =======================
// get the space list
exports.SPACE_LIST = '/space/list';
// create space
exports.CREATE_SPACE = '/space/create';
// delete space
exports.DELETE_SPACE = '/space/delete/:spaceId';
// switch space station
exports.SWITCH_SPACE = '/space/:spaceId/switch';
// immediately delete the space
exports.DELETE_SPACE_NOW = '/space/del';
// edit space
exports.UPDATE_SPACE = '/space/update';
// remove the red dot from the space list
exports.REMOVE_RED_POINT = '/space/remove/';
// exit space
exports.QUIT_SPACE = '/space/quit/';
// space station-main administrator-get main administrator information
exports.MAIN_ADMIN_INFO = '/space/manager';
// space station-main administrator-change main administrator
exports.CHANGE_MAIN_ADMIN = '/space/changeManager';
// Space Station-Sub-Administrator-Query the list of administrators
exports.LIST_ROLE = '/space/listRole';
// space station-sub-admin-get administrator information
exports.SUB_ADMIN_PERMISSION = '/space/getRoleDetail';
// space station-sub-admin-add admin
exports.ADD_SUB_ADMIN = '/space/addRole';
// space station-sub-admin-edit sub-admin
exports.EDIT_SUB_ADMIN = '/space/editRole';
// space station-sub-admin-delete-admin
exports.DELETE_SUB_ADMIN = '/space/deleteRole/';
// space station - change member settings
exports.UPDATE_MEMBER_SETTING = '/space/updateMemberSetting';
// Space Station - Get the status of prohibiting all members from exporting the Wig table
exports.FORBID_STATUS = '/space/getForbidStatus';
// space station - change workbench settings
exports.UPDATE_WORKBENCH_SETTING = '/space/updateWorkbenchSetting';
// space station - get the properties of space
exports.GET_SPACE_FEATURES = '/space/features';
// space station - get the properties of space
exports.SWITCH_NODEROLE_ASSIGNALE = '/space/updateNodeRoleAssignable';
// space station - update enterprise security settings
exports.UPDATE_SECURITY_SETTING = '/space/updateSecuritySetting';
// get the space content
exports.SPACE_CONTENT = '/space/content/';
// Spatial information
exports.SPACE_INFO = '/space/info/';
// restore space
exports.RECOVER_SPACE = '/space/cancel/';
// space capacity
exports.SPACE_MEMORY = '/space/capacity';
// Toggle the working directory to be visible to all members
exports.UPDATE_ALL_VISIBLE = '/space/updateNodeVisibleStatus';
// Query the visibility status of all members of the working directory
exports.GET_ALL_VISIBLE = '/space/getNodeVisible';
// spatial statistics
exports.SPACE_STATISTICS = '/space/statistics';
// subscribe
exports.SUBSCRIBE_INFO = '/space/subscribe/';
// permission related
exports.SPACE_RESOURCE = '/space/resource';
exports.NO_PERMISSION_MEMBER = '/node/remind/units/noPermission';
// Give attachment space capacity details
exports.CAPACITY_REWARD_LIST = '/space/capacity/detail';
// link invite
exports.CREATE_LINK = '/space/link/generate';
exports.LINK_LIST = '/space/link/list';
exports.DELETE_LINK = '/space/link/delete';
exports.LINK_VALID = '/space/link/valid';
exports.JOIN_VIA_LINK = '/space/link/join';
// apply to join the space
exports.APPLY_JOIN_SPACE = '/space/apply/join';
// =============== Space related =======================
//# sourceMappingURL=url.space.js.map